module.exports = __webpack_public_path__ + "static/media/social-01.3a8d2862.png";